import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { useToast } from "../../controller/ToastController";
import { CouponType } from "../../controller/UserController";
import { CouponModalType, couponModalState } from "../../recoil/couponModal";

const RecoilCouponModal: React.FC = () => {
  const showToast = useToast();
  const [modalStates, setModalStates] =
    useRecoilState<CouponModalType>(couponModalState);
  const [selectedCoupon, setSelectedCoupon] = useState<CouponType>();

  const getDiscount = () => {
    if (selectedCoupon) {
      return Number(selectedCoupon.price) > 0
        ? Number(selectedCoupon.price)
        : (modalStates.modalData.totalPrice * Number(selectedCoupon.percent)) /
            100 >
          Number(selectedCoupon.max_discount)
        ? Number(selectedCoupon.max_discount)
        : (modalStates.modalData.totalPrice * Number(selectedCoupon.percent)) /
          100;
    }
  };

  const closeModal = () => {
    setModalStates((prev) => ({
      ...prev,
      visibleConfirm: false,
      optionData: [],
    }));
  };
  const handleConfirm = () => {
    if (selectedCoupon) {
      modalStates.handleConfirm(selectedCoupon);
      closeModal();
    }
  };

  useEffect(() => {
    if (modalStates.modalData.usingCoupon)
      setSelectedCoupon(modalStates.modalData.usingCoupon);
  }, [modalStates.visibleConfirm]);

  return (
    <Style>
      {modalStates.visibleConfirm && (
        <div className="modalWrap">
          <div className="modal">
            <h2 className="header">쿠폰 선택</h2>
            <img
              className="closeIcon"
              onClick={closeModal}
              src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
              alt="close"
            />
            <div className="listWrap">
              {modalStates.modalData.coupons.map(
                (item: CouponType, index: number) => {
                  return (
                    modalStates.modalData.totalPrice >=
                      Number(item.requirement) && (
                      <div
                        key={index}
                        className={`listItem ${
                          selectedCoupon &&
                          item.user_coupon_id ===
                            selectedCoupon.user_coupon_id &&
                          "active"
                        }`}
                        onClick={() => setSelectedCoupon(item)}
                      >
                        <div>
                          <h2 className="title">
                            {item.name} •
                            {item.price === null
                              ? ` ${Number(item.percent)}%`
                              : ` ${Number(item.price)}원`}
                          </h2>
                          <h3>
                            {Number(item.requirement).toLocaleString()}원 이상
                            구매 시 사용
                            {item.max_discount !== null &&
                              `| 최대 ${Number(
                                item.max_discount
                              ).toLocaleString()}원`}
                          </h3>
                          <h3>{item.expire_date}까지</h3>
                        </div>
                        {selectedCoupon &&
                          item.user_coupon_id ===
                            selectedCoupon.user_coupon_id && (
                            <div className="checkWrap">
                              <div className="check">
                                <img
                                  src={`${process.env.PUBLIC_URL}/svg/ic_check.svg`}
                                  alt="check"
                                />
                              </div>
                              <h3>{getDiscount()!.toLocaleString()}원</h3>
                            </div>
                          )}
                      </div>
                    )
                  );
                }
              )}
            </div>
            <div className="footer" onClick={handleConfirm}>
              <button>선택완료</button>
            </div>
          </div>
        </div>
      )}
    </Style>
  );
};

export default RecoilCouponModal;

const Style = styled.div`
  .modalWrap {
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.4);
  }
  .modal {
    width: 40vw;
    max-height: 80vh;
    padding: 40px 50px;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 20px;
    background: #000;
    border: 1px solid #ffffff;
  }

  .header {
    text-align: center;
    font-size: 28px;
    padding-bottom: 30px;
  }
  .closeIcon {
    position: absolute;
    top: 5%;
    right: 4%;
    cursor: pointer;
  }

  .listWrap {
    flex: 1;
    overflow: scroll;
  }
  .listItem {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 40px;
    margin-bottom: 24px;
    border-radius: 10px;
    border: 1px solid #ffffff;
    h2 {
      font-size: 28px;
      line-height: 44px;
      font-weight: 500;
      white-space: pre-line;
      word-break: keep-all;
    }
    h3 {
      font-size: 20px;
      line-height: 30px;
      font-weight: 400;
      color: #a7a7a7;
    }
    h2.title {
      width: 400px;
    }
  }
  .listItem.active {
    padding: 20px 36px;
    border: 5px solid #ffffff;
  }

  .checkWrap {
    display: flex;
    flex-direction: column;
    align-items: center;
    .check {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      background: #6490e8;
    }
    h3 {
      padding-top: 10px;
      color: #6490e8;
    }
  }

  .footer {
    width: 100%;
    padding-top: 12px;
    button {
      width: 100%;
      padding: 10px 0;
      border-radius: 10px;
      background: linear-gradient(
        180deg,
        #5d88de 0%,
        #09276e 100%,
        #8c8c8c 100.01%
      );
      font-size: 40px;
      line-height: 56px;
      font-weight: 700;
      color: #ffffff;
    }
  }
`;
